import { HideableColumn } from './types'

export const HIDEABLE_COLUMNS: HideableColumn[] = ['SearchFilter']
export const EMPTY_VALUES = ['', ...[0, null, undefined].flatMap(v => [v, v?.toString()?.trim()])]
